export default __webpack_public_path__ + "static/media/delete.adda2e75.svg";